import { useEffect, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

const useTranslationLanguages = () => {
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    api
      .get(`${QUALITY_SERVICE_API_URL}/hub/translation/languages`)
      .then((res) => {
        setLanguages(res.data);
      })
      .catch((err) => {
        setError(err);
        console.error('Failed to fetch translation languages:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  return { languages, loading, error };
};

export default useTranslationLanguages;
